import Enums from '@core/types/api/Enums';
import { hasValue } from '@core/utils/equality';
import { hasPlantsLeft } from '@core/utils/locationRows';

import { useSlabQuery } from './useSlabQuery';

/** Whether another location row could still get an active plant; true until the plants load. */
export const useHasPlantsLeft = (rowPlantIds: Array<string | null>): boolean => {
  const { data: activePlants } = useSlabQuery('GET plants', {
    queryParams: {
      page: 0,
      perPage: 0,
      filterBy: [{ name: 'isArchived', operation: Enums.FilterOperation.Equals, values: [false] }],
    },
  });

  if (!hasValue(activePlants)) return true;

  return hasPlantsLeft(
    activePlants.items.map((plant) => plant.id),
    rowPlantIds,
  );
};
